export const configureSubDialogClassName =
  'mt-0 top-0 translate-y-0 data-[state=closed]:!slide-out-to-left-0 data-[state=closed]:!slide-out-to-top-0 data-[state=open]:!slide-in-from-left-0 data-[state=open]:!slide-in-from-top-0 sm:top-[50%] sm:-translate-y-1/2'
